import { render } from "./IconInfo.vue?vue&type=template&id=8fef42f8"
import script from "./IconInfo.vue?vue&type=script&lang=js"
export * from "./IconInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8fef42f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8fef42f8', __exports__)) {
    api.reload('8fef42f8', __exports__)
  }
  
  module.hot.accept("./IconInfo.vue?vue&type=template&id=8fef42f8", () => {
    api.rerender('8fef42f8', render)
  })

}


export default __exports__